import { greys, helpers, text } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";

const container = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  borderTop: `1px solid ${greys.cloudyBlue}`,
  padding: `${spacing.xs}px 12px`,
} as const;

const state = {
  paddingTop: spacing.std,
  paddingBottom: spacing.sm,
  transition: "all .5s",
  fontSize: typeStyles.size.md,
  color: greys.dark,
  fontFamily: typeStyles.fontFamilySans,
} as const;

const linearProgressErrorPrimary = {
  backgroundColor: text.error,
} as const;

const linearProgressErrorSecondary = {
  backgroundColor: helpers.lighten(text.error, 0.5),
} as const;

const loader = {
  minWidth: "100%",
  height: 10,
  marginBottom: 10,
  borderRadius: 5,
  overflow: "hidden", // needed for borderRadius to show
  backgroundColor: greys.paleGrey,
  boxShadow: `inset 0 1px 1px ${greys.cloudyBlue}`,
} as const;

export const styles = {
  container,
  state,
  linearProgressErrorPrimary,
  linearProgressErrorSecondary,
  loader,
} as const;
